/**
 * Detects lazy-route / dynamic-import failures after a deploy (stale chunk URLs).
 * Vite and webpack use different error names/messages.
 */
export function isChunkLoadError(error: unknown): boolean {
  if (!error) return false

  const err = error as Error
  if (err.name === 'ChunkLoadError') return true

  const message = (err.message ?? '').toLowerCase()
  return (
    message.includes('loading chunk') ||
    message.includes('failed to fetch dynamically imported module') ||
    message.includes('error loading dynamically imported module') ||
    message.includes('importing a module script failed') ||
    message.includes('unable to preload css')
  )
}
